<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false">
        <a-row>
          <!-- <a-col :span="8">
            <a-form-item label="用户信息的主键id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userKeyId']" placeholder="请输入用户信息的主键id"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="8">
            <a-form-item :label="$t('用户名')">
              <a-input v-decorator="['userId']" :placeholder="$t('请输入用户id')" style="width:96%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('表编号')">
              <a-input v-decorator="['userMeterId']" :placeholder="$t('请输入表编号')" style="width:96%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户上期读数')">
              <a-input-number v-decorator="['userMeterPreNum']" :placeholder="$t('请输入用户上期读数')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('上期抄表时间')">
              <a-time-picker :placeholder="$t('请选择上期抄表时间')" v-decorator="['userMeterPreDatetime']" :trigger-change="true" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('本期抄表时间')">
              <a-time-picker :placeholder="$t('请选择本期抄表时间')" v-decorator="['userMeterNowDatetime']" :trigger-change="true" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('本期抄表读数')">
              <a-input-number v-decorator="['userMeterNowNum']" :placeholder="$t('请输入本期抄表读数')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户本期用量')">
              <a-input-number v-decorator="['userMeterUseFlow']" :placeholder="$t('请输入用户本期用量')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户账单Id')">
              <a-input v-decorator="['userBillId']" :placeholder="$t('请输入用户账单Id')" style="width:96%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户账单金额')">
              <a-input-number v-decorator="['userBillNum']" :placeholder="$t('请输入用户账单金额')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('账单日期')">
              <j-date :placeholder="$t('请选择账单日期')" v-decorator="['userBillDate']" :trigger-change="true" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('账单是否结账')">
              <a-input-number v-decorator="['userBillIsEnd']" :placeholder="$t('请输入账单是否结账 0 未结账 1已结账')" style="width:96%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea v-decorator="['remark']" :placeholder="$t('请输入备注信息')" rows="4" style="width:98.8%" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="8">
            <a-form-item label="所属部门（客户公司）暂不用来做逻辑功能" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sysOrgCode']" placeholder="请输入所属部门（客户公司）暂不用来做逻辑功能"></a-input>
            </a-form-item>
          </a-col> -->
          <!-- <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col> -->
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'MeterUserBillListForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserBillList/add",
          edit: "/jeecg-charge/meter/meterUserBillList/edit",
          queryById: "/jeecg-charge/meter/meterUserBillList/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userKeyId','userId','userMeterId','userMeterPreNum','userMeterPreDatetime','userMeterNowNum','userMeterNowDatetime','userMeterUseFlow','userBillId','userBillNum','userBillDate','userBillIsEnd','remark','remark1','createTime','createBy','updateTime','updateBy','sysOrgCode'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'userKeyId','userId','userMeterId','userMeterPreNum','userMeterPreDatetime','userMeterNowNum','userMeterNowDatetime','userMeterUseFlow','userBillId','userBillNum','userBillDate','userBillIsEnd','remark','remark1','createTime','createBy','updateTime','updateBy','sysOrgCode'))
      },
    }
  }
</script>